import React from "react";
import { css } from "@emotion/react";
import PropTypes from "prop-types";
import Overlay from "components/Overlay";
import Tooltip from "components/Tooltip";
import { RateScoreDisplay } from "components/Missions/Applicants";
import { MatchScoreDisplay } from "components/Missions/Applicants";
import { Row } from "components/Containers";
import { convertToPercent } from "utils";
import { colors, fontSize } from "style";

/**
 * ApplicantScore
 *
 * @param {Object} scores
 * @param {Number} matchScore
 * @param {Object} scoreData
 * @param {Number} rateScore
 * @param {Object} hourlyRateData
 */
const ApplicantScore = ({ scores, matchScore, scoreData, rateScore, hourlyRateData }) => (
  <Row css={styles.container}>
    <div css={styles.item(0)}>
      <Tooltip tooltipId="Missions.Applicants.ApplicantScore.RankTooltip" key={scores?.vectorRank} hideIcon>
        {scores?.vectorRank ? scores.vectorRank : `-`}
      </Tooltip>
    </div>
    <div css={styles.item(Number(matchScore) * 100)}>
      <Overlay
        asCardOverlay
        overlay={<MatchScoreDisplay scores={scores} scoreData={scoreData} />}
        trigger={<span>{convertToPercent(matchScore)}</span>}
        placement="top"
        width="inherit"
      />
    </div>
    <div css={styles.item(Number(rateScore) * 100)}>
      <Overlay
        asCardOverlay
        overlay={<RateScoreDisplay rateData={hourlyRateData} currency={hourlyRateData?.currency} />}
        trigger={<span>{convertToPercent(rateScore)}</span>}
        placement="top"
        width="inherit"
      />
    </div>
  </Row>
);

const styles = {
  container: css`
    display: flex;
    justify-content: space-between;
    width: 13rem;
    font-size: ${fontSize.xsmall};
    border-radius: 2.4rem;
    color: #fff;
    gap: 0;
    overflow: hidden;

    > *:first-of-type {
      border-left-width: 0;
    }
  `,
  item: (score) => css`
    padding: 0.4rem 0;
    border-left: 1px solid rgba(255, 255, 255, 0.4);
    text-align: center;
    flex: 1;
    background: ${score < 60 ? colors.grayAnatomyBase : colors.green};
  `,
};

ApplicantScore.propTypes = {
  scores: PropTypes.object,
  matchScore: PropTypes.number,
  scoreData: PropTypes.object,
  rateScore: PropTypes.number,
  hourlyRateData: PropTypes.object,
};

export default ApplicantScore;
